export const initialRoomState = {
  id: null,
  players: [],
  name: null,
  quiz_id: null,
  board_cases: [],
  current_player_index: null,
};

export const roomReducer = (state = initialRoomState, action) => {
  switch (action.type) {
    case "SET_ROOM":
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
